<div class="team-members-container py-4">
    <div fxLayoutAlign="space-between center" class="mb-8">
        <h2 class="my-16 font-normal text-lg">{{ 'TEAMS.MEMBER.TITLE' | translate }} ({{ teamMembersTotalCount$ | async }})</h2>

        <app-white-button
            [icon]="'add'"
            [label]="'TEAMS.MEMBER.BUTTON.ADD_MEMBER'"
            (onClick)="openAddDialog()"
            *ngIf="(teamMembersTotalCount$ | async) && canManageTeamMembers"
        ></app-white-button>
    </div>

    <div class="team-members" *ngIf="(teamService.teamMembers$ | async).length; else noTeamMembers">
        <div fxLayout="row wrap" fxLayoutAlign="flex-start space-between" fxLayoutGap="8px grid" class="pb-8">
            <mat-card
                appearance="outlined"
                fxLayout="row"
                fxLayoutAlign="flex-start space-between"
                fxFlex="1 0 calc(100%-8px)"
                fxFlex.gt-xs="1 0 calc(50%-8px)"
                fxFlex.gt-md="1 0 calc(33%-8px)"
                class="mb-12 p-16 pr-4 team-member-card-container mat-elevation-z0 pointer"
                *ngFor="let teamMember of teamService.teamMembers$ | async"
                (click)="goToTeamMember(teamMember.user.id)"
            >
                <mat-card-content fxLayout="column" class="w-100-p mr-4">
                    <div fxLayout="row" fxLayoutAlign="space-between flex-start" class="w-100-p mb-24">
                        <div fxLayout="row" fxFlex="60%">
                            <div class="relative user-details-card-container">
                                <div #userAvatar class="pointer">
                                    <img
                                        class="avatar mr-8"
                                        *ngIf="teamMember.user.avatar.src; else initials"
                                        [alt]="teamMember.user.fullName"
                                        [src]="teamMember.user.avatar.src"
                                    />
                                    <ng-template #initials>
                                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ teamMember.user.fullName | initials }}</div>
                                    </ng-template>
                                </div>
                                <app-user-details-card [user]="teamMember.user" [target]="userAvatar" openedFrom="team_admin_space"></app-user-details-card>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="flex-start center" class="mr-8" class="team-member-info ellipsis-container w-full">
                                <h3 class="m-0 ellipsis-container font-normal">{{ teamMember.user.fullName }}</h3>
                            </div>
                        </div>

                        <div fxLayout="row" fxFlex="40%" fxLayoutAlign="flex-end">
                            <button
                                class="more-menu"
                                mat-icon-button
                                [matMenuTriggerFor]="moreMenu"
                                aria-label="More"
                                (click)="$event.stopPropagation()"
                                *ngIf="canManageTeamMembers"
                            >
                                <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                            </button>
                        </div>

                        <mat-menu #moreMenu="matMenu" xPosition="before">
                            <button mat-menu-item aria-label="remove" (click)="openRemoveTeamMemberDialog(teamMember)">
                                <mat-icon>delete</mat-icon>
                                <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                            </button>
                        </mat-menu>
                    </div>
                    <div fxLayout="row wrap" fxLayoutAlign="flex-start space-between" fxLayoutGap="8px" *ngIf="teamMember.charts.length; else noProgress">
                        <div fxFlex="calc(50%-8px)" class="stats-wrapper">
                            <app-course-completion class="w-100-p" [charts]="teamMember.charts" [hideChartTitle]="true"></app-course-completion>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="center space-between" fxFlex="calc(50%-8px)" fxLayoutGap="8px" class="mr-8">
                            <div fxLayout="row" fxLayoutAlign="flex-start center" class="p-16 stats-wrapper">
                                <div fxLayout="row" fxLayoutAlign="center center" class="chart-wrapper">
                                    <div
                                        fxLayoutAlign="center center"
                                        class="icon-wrapper mr-12"
                                        [ngStyle]="{
                                            background: '#F0BFDF',
                                            fill: '#C5639C'
                                        }"
                                    >
                                        <mat-icon svgIcon="dashboard_grow_daily_posting_link_followed"></mat-icon>
                                    </div>
                                    <span>{{ teamMember.yearlyActiveDays || 0 }}</span>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="flex-start center" class="p-16 stats-wrapper">
                                <div fxLayout="row" fxLayoutAlign="center center" class="chart-wrapper">
                                    <div
                                        fxLayoutAlign="center center"
                                        class="icon-wrapper mr-12"
                                        [ngStyle]="{
                                            background: '#D5E1A4',
                                            fill: '#95AF3F'
                                        }"
                                    >
                                        <mat-icon svgIcon="dashboard_avg_learning_time"></mat-icon>
                                    </div>
                                    <span>{{ teamMember.totalLearningTime | msToHumanizeTimePipe }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ng-template #noProgress>
                        <div class="stats-wrapper p-12 pr-20 mr-8" fxLayoutAlign="center center">
                            <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 0 100%">
                                <mat-icon class="participant-view-illustration" svgIcon="team_progress_illustration"></mat-icon>
                                <div fxLayout="column">
                                    <h3 class="mt-8 mb-4">{{ 'TEAMS.TEAM_PROGRESS.LABEL.NO_PROGRESS_YET' | translate }}</h3>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>

        <div
            fxLayout="row wrap"
            fxLayoutAlign="flex-start space-between"
            fxLayoutGap="8px grid"
            class="pb-8"
            *ngIf="isLoadingMore"
        >
            <div
                *ngFor="let _ of shimmerPlaceholders"
                fxFlex="1 0 calc(100%-8px)"
                fxFlex.gt-xs="1 0 calc(50%-8px)"
                fxFlex.gt-md="1 0 calc(33%-8px)"
                class="mb-12 team-member-card-container"
            >
                <div class="shimmer-card module animate !max-w-full"></div>
            </div>
        </div>

        <div
            #loadMoreSentinel
            class="team-members-scroll-sentinel"
            *ngIf="!isLoadingMore && (teamService.teamMembers$ | async).length < (teamMembersTotalCount$ | async)"
        ></div>
    </div>

    <ng-template #noTeamMembers>
        <div fxLayout="column" fxLayoutAlign="center center" class="no-team-members-container py-48 px-24 bg-white">
            <mat-icon class="participant-view-illustration" svgIcon="members_illustration"> </mat-icon>
            <h3 class="mt-8 mb-16">
                {{ 'TEAMS.MEMBER.LABEL.NO_MEMBERS_YET' | translate }}
            </h3>

            <app-flat-button [icon]="'add'" [label]="'TEAMS.MEMBER.BUTTON.ADD_MEMBER'" (onClick)="openAddDialog()" *ngIf="canManageTeamMembers"></app-flat-button>
        </div>
    </ng-template>
</div>
